import React from 'react';
import {
  LongBody,
  ShortBody,
  PageTitle,
  MediumSectionHeader,
} from 'components/Typography';
import styled from 'styled-components';
import HeaderImage from 'images/Espace-client-saham-assurance.jpg';
import HeaderImageAR from 'images/Espace-client-saham-assurance-AR.jpg';
import { Grid, FormControlLabel } from '@material-ui/core';
import { Captions } from 'components/Typography';

export const paperStyle = {
  borderRadius: '8px',
  padding: '24px 32px',
  boxShadow: '0 1px 1px 0 rgba(0,0,0,0.03), 0 0 24px 0 rgba(0,0,0,0.08)',
};

export const formStyle = {
  checkbox: {
    padding: 0,
    paddingRight: '10px',
  },
  gridMarginBottom: {
    marginBottom: '15px',
  },
  forgetPasswordStyle: {
    color: '#0880BC',
    textDecoration: 'underline',
  },
  infoIcon: {
    cursor: 'pointer',
    '&:hover': {
      background: 'rgba(0,0,0,0.04)',
      borderRadius: '50%',
    },
  },
};

export const Wrapper = styled(({ matches, reverse, ...props }) => (
  <div {...props} />
))`
  min-height: 910px;
  min-height: 93vh;
  background-image: ${(props) =>
    props.reverse ? `url( ${HeaderImageAR})` : `url( ${HeaderImage})`};
  background-position: center 100%;
  background-size: cover;
`;

export const StyledShortBody = styled(ShortBody)`
  margin-bottom: 5px !important;
`;

export const SizedLongBody = styled(LongBody)`
  && {
    margin-bottom: 0px;
  }
`;

export const StyledBodyText = styled.p`
  color: #162952;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
  max-height: 500px;
  margin: 0px;
  overflow: auto;
`;
export const StyledGrid = styled(({ matches, ...props }) => (
  <Grid {...props} />
))`
  margin-bottom: ${(props) => (props.matches ? '40px' : '52px')} !important;
  margin-top: ${(props) => (props.matches ? '24px' : '30px')} !important;
`;
export const BlockIcon = styled.div`
  height: 48.8px !important;
  width: 46.4px !important;
  margin-left: 10px !important;
  margin-bottom: 10px !important;
  text-align: center !important;
`;
export const BlockImg = styled.div`
  height: 36px !important;
  width: 36px !important;
`;
export const StyledIcon = styled.div`
  height: 48px !important;
  width: 48px !important;
  margin-bottom: 10px !important;
  text-align: center !important;
`;
export const StyledGridTitle = styled(({ matches, ...props }) => (
  <Grid {...props} />
))`
  ${(props) =>
    props.matches
      ? 'letter-spacing: 0; height: 24px; line-height: 24px; margin-left: 0px'
      : ' margin-top: 6px'} !important;

  .MuiTypography-h5 {
    font-size: ${(props) => (props.matches ? '14px' : '16px')};
  }
`;

export const StyledPageTitle = styled(({ matches, ...props }) => (
  <PageTitle {...props} />
))`
  && {
    font-size: ${(props) => (props.matches ? '24px' : '32px')};
    line-height: ${(props) => (props.matches ? '29px' : '48px')};
    letter-spacing: ${(props) => (props.matches ? ' -0.27px' : '0px')};
    margin-bottom: ${(props) => (props.matches ? '0px' : '67px')};
  }
`;

export const StyledFormControlLabel = styled(({ reverse, ...props }) => (
  <FormControlLabel {...props} />
))`
  &&& {
    margin-right: ${(props) => (props.reverse ? '-11px' : '')};
    margin-bottom: 20px;
    .MuiFormControlLabel-label {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export const StyledCaption = styled(Captions)`
  && {
    margin-bottom: 0px;
  }
`;

export const StyledMediumSectionHeader = styled(MediumSectionHeader)`
  && {
    margin-bottom: 24px;
  }
`;
